module.exports = __webpack_public_path__ + "img/follow_3.96b9f93b.png";